module.exports = __webpack_public_path__ + "img/Postmodernisme_Marianne-Heske.578062f0.jpg";